/* eslint-disable @typescript-eslint/ban-ts-comment */
import { shouldPolyfill as shouldPolyfillLocale } from "@formatjs/intl-locale/should-polyfill";
import { shouldPolyfill as shouldPolyfillNumberFormat } from "@formatjs/intl-numberformat/should-polyfill";
import { shouldPolyfill as shouldPolyfillPluralRules } from "@formatjs/intl-pluralrules/should-polyfill";

async function intlPluralRulesPolyfill() {
  if (shouldPolyfillPluralRules()) {
    await import(/* webpackChunkName: "intl-plurarrules-polyfill" */ "@formatjs/intl-pluralrules/polyfill");
  }
  if ((Intl.PluralRules as any).polyfilled) {
    // @ts-expect-error
    await import(/* webpackChunkName: "intl-plurarrules-polyfill" */ "@formatjs/intl-pluralrules/locale-data/en");
  }
}

async function intlLocalePolyfill() {
  if (shouldPolyfillLocale()) {
    await import(/* webpackChunkName: "intl-locale-polyfill" */ "@formatjs/intl-locale/polyfill");
  }
}

export async function intlNumberFormatPolyfill() {
  if (shouldPolyfillNumberFormat()) {
    await import(/* webpackChunkName: "intl-numberformat-polyfill" */ "@formatjs/intl-numberformat/polyfill");
    await import(/* webpackChunkName: "intl-numberformat-polyfill" */ "@formatjs/intl-numberformat/locale-data/en");
  }
}

export async function applyPolyfills() {
  await intlLocalePolyfill();
  await Promise.all([intlNumberFormatPolyfill(), intlPluralRulesPolyfill()]);
}
